import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

// Helper to get last 12 months
const getLast12Months = () => {
  const months = [];
  const today = new Date();

  for (let i = 11; i >= 0; i--) {
    const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
    months.push({
      label: d.toLocaleString("default", { month: "short", year: "numeric" }),
      month: d.getMonth() + 1,
      year: d.getFullYear(),
    });
  }
  return months;
};

const formatCurrency = (val) => {
  if (val >= 100000) {
    return `₹${(val / 100000).toFixed(2)} L`;
  }
  if (val >= 1000) {
    return `₹${(val / 1000).toFixed(1)} k`;
  }
  return `₹${val}`;
};

const MonthlyRevenueTrend = ({ apiData = [] }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const months = getLast12Months();

    const counts = months.map((m) => {
      const found = apiData.find(
        (d) => Number(d.month) === Number(m.month) && Number(d.year) === Number(m.year)
      );
      return found ? (Number(found.total) || 0) : 0;
    });

    setChartData({
      labels: months.map((m) => m.label),
      datasets: [
        {
          label: "Monthly Revenue (₹)",
          data: counts,
          borderColor: "#27ae60",
          backgroundColor: "rgba(39, 174, 96, 0.15)",
          fill: true,
          tension: 0.35,
          pointRadius: 4,
          pointHoverRadius: 6,
          pointBackgroundColor: "#27ae60",
        },
      ],
    });
  }, [apiData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `Revenue: ₹${context.raw.toLocaleString("en-IN")}`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => formatCurrency(value)
        }
      }
    }
  };

  return (
    <div className="col-xl-6">
      <div className="card pending-app mt-2 mb-4">
        <div className="card-body p-3">
          <h4>
            <i className="far fa-money-bill-wave-alt" style={{ marginRight: 8, color: "#27ae60" }} />
            Monthly Revenue Trend
          </h4>

          <div style={{ height: 300 }}>
            {chartData.labels && <Line data={chartData} options={options} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyRevenueTrend;
